<template>
      <v-radio-group v-model="paymentOption" :mandatory="false">
      <div
        style="min-height: 77px;"
        class="radio-option-paypal"
        @click="paymentOption = option.id"
        :class="paymentOption == option.id ? 'option-active' : 'option-deactive'"
      >
      <v-layout class="radio-option__info">
        <v-flex>
          <v-layout row>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="2em" height="2em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M8.32 21.97a.546.546 0 0 1-.26-.32c-.03-.15-.06.11.6-4.09c.6-3.8.59-3.74.67-3.85c.13-.17.11-.17 1.61-.18c1.32-.03 1.6-.03 2.19-.12c3.25-.45 5.26-2.36 5.96-5.66c.04-.22.08-.41.09-.41c0-.01.07.04.15.1c1.03.78 1.38 2.22.99 4.14c-.46 2.29-1.68 3.81-3.58 4.46c-.81.28-1.49.39-2.69.42c-.8.04-.82.04-1.05.19c-.17.17-.16.14-.55 2.55c-.27 1.7-.37 2.25-.41 2.35c-.07.16-.21.3-.37.38l-.11.07H10c-1.29 0-1.62 0-1.68-.03m-4.5-2.23c-.19-.1-.32-.27-.32-.47C3.5 19 6.11 2.68 6.18 2.5c.09-.18.32-.37.5-.44L6.83 2h3.53c3.91 0 3.76 0 4.64.2c2.62.55 3.82 2.3 3.37 4.93c-.5 2.93-1.98 4.67-4.5 5.3c-.87.21-1.48.27-3.14.27c-1.31 0-1.41.01-1.67.15c-.26.15-.47.42-.56.75c-.04.07-.27 1.47-.53 3.1a241.3 241.3 0 0 0-.47 3.02l-.03.06H5.69c-1.58 0-1.8 0-1.87-.04z" fill="#626262"/></svg>
        <div class="radio-option__info-text">
          <label :for="option.id">{{ option.label }}</label>
        </div>
          </v-layout>
        </v-flex>
        <v-flex shrink>
          <v-radio style="margin-right: 6px;" color="primary" :id="option.id" :value="option.id"></v-radio>
        </v-flex>
      </v-layout>

      <v-card flat v-if="paymentOption === 'PP'">
        <v-container align-center>
           <!-- <PayPal
              v-if="canPurchase"
              :amount="productsTotal"
              :invoice-number="getBtInvoice()"
              :items="paypalItems"
              currency="BRL"
              locale="pt_BR"
              :button-style="myStyle"
              :env="checkEnviroment()"
              :client="credentials"
              @payment-authorized="autorizedTransaction"
              @payment-completed="completedTransaction"
              @payment-cancelled="errorTransaction"
            >
            </PayPal> -->
            <div>
              <v-btn
              style="min-height: 50px"
              block
              round
              depressed
              class="normal-text btn-disabled"
              color="info"
              dark
            ><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="2em" height="2em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M8.32 21.97a.546.546 0 0 1-.26-.32c-.03-.15-.06.11.6-4.09c.6-3.8.59-3.74.67-3.85c.13-.17.11-.17 1.61-.18c1.32-.03 1.6-.03 2.19-.12c3.25-.45 5.26-2.36 5.96-5.66c.04-.22.08-.41.09-.41c0-.01.07.04.15.1c1.03.78 1.38 2.22.99 4.14c-.46 2.29-1.68 3.81-3.58 4.46c-.81.28-1.49.39-2.69.42c-.8.04-.82.04-1.05.19c-.17.17-.16.14-.55 2.55c-.27 1.7-.37 2.25-.41 2.35c-.07.16-.21.3-.37.38l-.11.07H10c-1.29 0-1.62 0-1.68-.03m-4.5-2.23c-.19-.1-.32-.27-.32-.47C3.5 19 6.11 2.68 6.18 2.5c.09-.18.32-.37.5-.44L6.83 2h3.53c3.91 0 3.76 0 4.64.2c2.62.55 3.82 2.3 3.37 4.93c-.5 2.93-1.98 4.67-4.5 5.3c-.87.21-1.48.27-3.14.27c-1.31 0-1.41.01-1.67.15c-.26.15-.47.42-.56.75c-.04.07-.27 1.47-.53 3.1a241.3 241.3 0 0 0-.47 3.02l-.03.06H5.69c-1.58 0-1.8 0-1.87-.04z" fill="#FFFFFF"/></svg>
            Preencha seus dados pessoais</v-btn>
            </div>
        </v-container>
      </v-card>
      </div>
      </v-radio-group>
</template>

<script>
import { mapGetters } from 'vuex';
// import PayPal from 'vue-paypal-checkout'

export default {
  components: {
    // PayPal
  },
  data() {
    return {
      payerId: null,
      paymentId: null,
      paymentToken: null,
      paypalId: null,
      paypalItems: [],
      option: {
        id: 'PP',
        label: 'Paypal',
        info: '',
      },
      paypal: {
        sandbox: '',
        production: ''
      },
      credentials: {
        sandbox: '',
        production: ''
      },
       myStyle: {
        label: '',
        size:  'responsive',
        shape: 'pill',
        color: 'blue'
      },
      loads: null,
      specialCode: null,
    };
  },
  watch: {
    paymentOption () {
      if (this.paymentOption === 'PP' && this.userProps.name && this.userProps.document) {
        this.cardName = this.userProps.name
        this.cardCPF = this.userProps.document
      }
    }
  },
  methods: {
    mountPaypalCart () {
      this.cartProducts.forEach(cp => {
        cp.forEach(pd => {
          this.paypalItems.push({
            name: pd.nome_evento + ' - ' + pd.nome + ' - ' + pd.nome_tipo,
            description: '',
            quantity: pd.quantidade,
            price: pd.valor + pd.valor_conveniencia,
            sku: pd.codigo_produto,
            currency: 'BRL'
          })
        })
      })
    },
    validateCNPJ(cnpj) {
      if (cnpj && cnpj.length) {
      cnpj = cnpj.replace(/[^\d]+/g,'');

      if(cnpj === '') return false;

      if (cnpj.length !== 14)
          return false;

      // Elimina CNPJs invalidos conhecidos
      if (cnpj === "00000000000000" ||
          cnpj === "11111111111111" ||
          cnpj === "22222222222222" ||
          cnpj === "33333333333333" ||
          cnpj === "44444444444444" ||
          cnpj === "55555555555555" ||
          cnpj === "66666666666666" ||
          cnpj === "77777777777777" ||
          cnpj === "88888888888888" ||
          cnpj === "99999999999999")
          return false;

      // Valida DVs
      let tamanho = cnpj.length - 2
      let numeros = cnpj.substring(0,tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
              pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (parseInt(resultado) !== parseInt(digitos.charAt(0)))
          return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0,tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
              pos = 9
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (parseInt(resultado) !== parseInt(digitos.charAt(1)))
            return false

      return true
    } else {
      return false
    }
    },
    validateCPF(cpf) {
      let numeros;
      let digitos;
      let soma;
      let i;
      let resultado;
      let digitosIguais;
      digitosIguais = 1;
      cpf = cpf.replace(/-|\./g, '');
      if (cpf.length < 11) {
        return false;
      }
      for (i = 0; i < cpf.length - 1; i++) {
        if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
          digitosIguais = 0;
          break;
        }
      }
      if (!digitosIguais) {
        numeros = cpf.substring(0, 9);
        digitos = cpf.substring(9);
        soma = 0;
        for (i = 10; i > 1; i--) {
          soma += numeros.charAt(10 - i) * i;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(0))) {
          return false;
        }
        numeros = cpf.substring(0, 10);
        soma = 0;
        for (i = 11; i > 1; i--) {
          soma += numeros.charAt(11 - i) * i;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(1))) {
          return false;
        }
        return true;
      }
      return false;
    },
    getBtInvoice () {
      return this.$store.getters.eventID + '-' + this.$store.getters.body.codigo_pedido
    },
    checkEnviroment () {
      if (process.env.VUE_APP_ENV === 'development') return 'sandbox'
      else return 'production'
    },
     errorTransaction (value) {
      this.payerId = null
      this.paymentId = null
      this.paymentToken = null
      this.paypalId = null
    },
    completedTransaction (value) {
      localStorage.setItem('iframePurcheased', true);
      this.$store.dispatch('addLoading');
      const orderId = this.$route.name === 'commissioner' ? this.orderPdvData.codigo_pedido : this.$store.getters.body.codigo_pedido;
      const { productsQuantity } = this.$store.getters;
      this.paypalId = value.transactions[0].related_resources[0].sale.id

        const params = {
          payer_id: this.payerId,
          payment_id: this.paymentId,
          payment_token: this.paymentToken,
          paypal_id: this.paypalId,
          customer_name: this.userProps.name,
          customer_doc: this.userProps.document,
          customer_email: this.userProps.email,
          customer_phone: this.userProps.phone,
          customer_address: this.userProps.address,
          customer_address_number: this.userProps.number,
          customer_address_complement: this.userProps.complement,
          customer_zipcode: this.userProps.cep,
          customer_neighborhood: this.userProps.neighborhood,
          customer_city: this.userProps.city,
          customer_state: this.userProps.state,
          customer_country: this.userProps.country,
          delivery_option_id: this.$store.getters.deliveryOption,
          event_id: this.$store.getters.eventID,
          installment_amount: 1,
          interest_amount: 0,
          order_id: orderId,
          payment_type_id: 7, // Paypal
          products_amount: productsQuantity,
          total: Math.round(parseFloat(this.$store.getters.totalAmount)),
      };

        if (this.$store.getters.userProps.email) {
          params.customer_email = this.$store.getters.userProps.email;
        }

        if (this.$store.getters.buyerData.clientID) {
          params.user_id = this.$store.getters.buyerData.clientID;
        }

        this.$axios.post('/orders/charge/digital/paypal/capture', params
        ).then((res) => {
          const postOrder = {
        ...this.$store.getters.postOrder,
        email: this.userProps.email,
        phone: this.userProps.phone,
        status: 'Aprovado',
        card: ``,
        instalments: ``,
        hash_pedido: this.$store.getters.body.hash_pedido,
        payment: this.$store.state.paymentOption,
        organizador: res.data.orderData.nome_organizador,
        cpf_organizador: res.data.orderData.org_cpf,
        cnpj_organizador: res.data.orderData.org_cnpj,
        mensagem: res.data.orderData.mensagem_conclusao_pedido
      };

      this.$store.dispatch('setPostOrder', postOrder);
      this.$store.dispatch('setBody', {
        ...this.$store.getters.body,
        expiration: 0,
      });
      this.$store.commit('SET_TICKET_URL', res.data.orderData.ticketsUrl);
      console.log('setPurchaseStarted - completedTransaction - false')
      this.$store.dispatch('setPurchaseStarted', false);
      this.$store.dispatch('nextStep')
      this.$store.dispatch('saveBuyerData')
      this.$store.dispatch('subtractLoading');
        })
    },
    autorizedTransaction (value) {
      this.payerId = value.payerID
      this.paymentId = value.paymentID
      this.paymentToken = value.paymentToken
    },
    updateLoads(data) {
      data = data.value;
      this.body = {
        ...this.body,
        parcelas: data.instalments,
      };
      this.$store.dispatch('setInstalmentAmount', data.instalments);
      this.$store.dispatch('setInterestAmount', data.interestAmount);
      this.$store.dispatch('setTotalAmount', data.total);
    },
  },
  computed: {
    ...mapGetters({
      userProps: 'userProps',
      cartProducts: 'cartProducts',
      paypalClientId: 'paypalClientId',
      orderPdvData: 'orderPdvData'
    }),
    canPurchase() {
      let hasUserProps = false;

      if (this.userProps && this.userProps.name && (this.userProps.email === this.userProps.emailConfirmation) && this.userProps.phone && this.userProps.document) {
        if (this.userProps.selectedDocument === 'cpf' && this.validateCPF(this.userProps.document)) hasUserProps = true
        if (this.userProps.selectedDocument === 'cnpj' && this.validateCNPJ(this.userProps.document)) hasUserProps = true
        if (this.userProps.selectedDocument === 'foreigner' && this.userProps.document) hasUserProps = true
      }

      return hasUserProps;
    },
    productsTotal() {
      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += (v.valor + v.valor_conveniencia) * v.quantidade;
        });
      });
      total = somador;
      return total.toFixed(2);
    },
    body: {
      get() {
        return this.$store.getters.body;
      },
      set(value) {
        this.$store.dispatch('setBody', value);
      },
    },
    paymentOption: {
      get() {
        return this.$store.getters.paymentOption;
      },
      set(value) {
        this.$store.dispatch('setPaymentOption', value);
      },
    },
  },
  mounted () {
    this.mountPaypalCart()
    this.paypal.sandbox = this.paypalClientId
    this.paypal.production = this.paypalClientId
    this.credentials.sandbox = this.paypalClientId
    this.credentials.production = this.paypalClientId
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/payment/paymentPaypal.styl'
@import '~@/assets/payment/paymentBillet.styl'
</style>

<style>
.custom-text .v-label {
  top: 18px !important;
}
</style>
